import AuthService from "../../services/AuthService";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useParams, useHistory } from "react-router-dom";

export default function RedirectToSplashScreen() {
    const { tipo, identificador } = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();

    useEffect(() => {
        let service = new AuthService();

        service.get(`/identificador/get/${tipo}/${identificador}`)
            .then((res) => {
                const hash = res?.uuid;
                if (hash) {
                    history.replace(`/checkout/${hash}`);
                }
            })
            .catch((err) => {
                enqueueSnackbar(`Não existe ${tipo} - Número ${identificador}. Entre em contato com um garçom.`, { variant: 'error' })
                history.replace("/errorsLojaNaoEncontrada");
            });

    }, []);

    return null;
}